import React from "react";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import LargeContainer from "../LargeContainer";
import MainContainer from "../MainContainer";

const HeroSection = () => {
  return (
    <HeroContainer>
      <Icons className="hidden">
        <FaAngleLeft />
      </Icons>

      <MainContainer style={{ minHeight: "730px" }}>
        <Left>
          <div style={{ fontSize: "3rem", fontWeight: "300" }}>65% OFF</div>
          <div style={{ fontSize: "6rem", fontWeight: "400" }}>NEW PLANT</div>
          <div style={{ fontSize: "1.5rem", fontWeight: "400" }}>
            Pronia, With 100% Natural, Organic & Plant Shop.
          </div>
          <Button to="/shop">DISCOVER NOW</Button>
        </Left>
        <Right>
          <img src="./hero_1.png" alt="hero" />
        </Right>
      </MainContainer>

      <Icons className="hidden">
        <FaAngleRight />
      </Icons>
    </HeroContainer>
  );
};
const Icons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  margin: 0.5em;
  padding: 0.8em;
  cursor: pointer;
  color: #999;
  background-color: #fff;
  opacity: 0;
  transition: opacity 0.5s;
  :hover {
    color: #83aa4c;
  }
`;

const HeroContainer = styled(LargeContainer)`
  background-color: #f9efe9;
  align-items: center;
  justify-content: space-between;
  :hover {
    .hidden {
      opacity: 100;
    }
  }
`;

const Left = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 50%;
  align-items: flex-start;
`;
const Right = styled.div`
  display: flex;
  align-items: center;
  width: 50%;
`;
const Button = styled(NavLink)`
  text-decoration: none;

  margin-top: 3em;
  padding: 1.5em 4em;
  background-color: #83aa4c;
  border-radius: 32px;
  flex-grow: 0;
  color: white;
  cursor: pointer;
  scale: 1;
  transition: scale 0.5s;
  :hover {
    scale: 1.1;
  }
`;

export default HeroSection;
